import { createElement, forwardRef, type HTMLAttributes } from 'react';

import { cn } from '@/lib/utils';

/**
 * Objeto de blueprint do Design System (ADR-0065, emendada em 2026-08-01):
 * desenho de linha em vez de bloco sólido — fundo transparente, borda hairline
 * e cantos retos.
 *
 * As quatro marcas de registro "+" desenhadas para fora da caixa saíram a
 * pedido do owner (E62.F1): a moldura sozinha já diz que o objeto é um desenho
 * de linha, e a marca em cada quina de cada borda poluía a leitura das telas
 * densas. Com elas foi embora a razão do `overflow: visible`.
 */

/** Tags que fazem sentido como moldura. Evita polimorfismo aberto sem uso real. */
export type BlueprintElement =
  | 'div'
  | 'section'
  | 'article'
  | 'aside'
  | 'figure'
  | 'li'
  | 'fieldset';

export interface BlueprintProps extends HTMLAttributes<HTMLElement> {
  as?: BlueprintElement;
}

export const Blueprint = forwardRef<HTMLElement, BlueprintProps>(function Blueprint(
  { as = 'div', className, children, ...props },
  ref,
) {
  return createElement(
    as,
    {
      ref,
      'data-blueprint': '',
      className: cn('relative border border-border bg-transparent', className),
      ...props,
    },
    children,
  );
});
